if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.isEnded = false;
    }

    connectedCallback() {
      const dateStr = this.dataset.deadline;
      this.deadline = new Date(dateStr);

      if (isNaN(this.deadline.getTime())) {
        const parts = dateStr.match(/(\d{1,2})\s+(\w{3})\s+(\d{4})/);
        if (parts) {
          const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          const day = parseInt(parts[1]);
          const month = months.indexOf(parts[2]);
          const year = parseInt(parts[3]);
          this.deadline = new Date(year, month, day, 23, 59, 59);
        }
      }

      if (!isNaN(this.deadline.getTime())) {
        this.timer();
      } else {
        console.error('Invalid countdown date format:', dateStr);
      }
    }

    timer() {
      const updateTimer = () => {
        const now = new Date();
        const remainingTime = this.deadline - now;

        if (remainingTime <= 0) {
          this.isEnded = true;
          this.textContent = '00:00:00';
          this.classList.add('is-ended');
          clearInterval(this.interval);
          return;
        }

        const totalSeconds = Math.floor(remainingTime / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        this.textContent = formattedTime;
      };

      updateTimer();

      this.interval = setInterval(updateTimer, 1000);
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
